import { useEffect } from 'react';

import { appConfig } from 'appConfig';
import { getItem, reset } from 'utils/localstorage';
import { isAllowedLogoutRedirectUrl } from 'utils/logoutRedirect';
import { SESSION_KEY, IMPERSONATE_SESSION_KEY } from 'utils/constants';

export default function PlatformLogout() {
  useEffect(() => {
    async function run() {
      const returnUrl = new URLSearchParams(window.location.search).get(
        'return_url'
      );
      const sid = getItem(IMPERSONATE_SESSION_KEY) || getItem(SESSION_KEY);
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 3_000);
      try {
        const apiBase = appConfig.apiBaseUrl.replace(/\/$/, '');
        await fetch(`${apiBase}/api/light/auth/platform/logout/`, {
          method: 'POST',
          credentials: 'include',
          headers: sid ? { Authorization: `Bearer ${sid}` } : {},
          signal: controller.signal,
        });
      } catch (_) {
        // best-effort — always clear local state and continue
      } finally {
        clearTimeout(timer);
      }
      reset();
      sessionStorage.clear();
      const safeUrl =
        returnUrl !== null &&
        isAllowedLogoutRedirectUrl(
          returnUrl,
          appConfig.allowedLogoutRedirectUrls
        )
          ? returnUrl
          : '/login';
      window.location.href = safeUrl;
    }
    run();
  }, []);

  return null;
}
